import React, { FC } from 'react';
import { isUndefined, omit } from 'lodash';
import { Field, FieldProps, useFormikContext } from 'formik';

import Switch from 'vibo-ui/Switch';

import { FormSwitchProps } from './interfaces';

const FormSwitch: FC<FormSwitchProps> = ({ name, ...rest }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Field name={name}>
      {({ field }: FieldProps) => {
        const isDefaultOff = isUndefined(rest.defaultChecked);

        const fieldProps = {
          ...omit(field, isDefaultOff ? '' : 'value'),
          ...(isDefaultOff ? { checked: field.value } : {}),
        };

        return (
          <Switch
            {...fieldProps}
            {...rest}
            onChange={(checked, e) => {
              setFieldValue(field.name, checked);
              rest.onChange?.(checked, e);
            }}
          />
        );
      }}
    </Field>
  );
};

export default FormSwitch;
